module.exports = __webpack_public_path__ + "static/media/bookmark.1e8f20ab.svg";